import React from "react";

export default function HorizonRing({ size = 90, stroke = 10, pct = 40, color = "#FF2052", label }) {
    const r = (size - stroke) / 2;
    const c = Math.PI * 2 * r;
    const dash = (Math.min(100, Math.max(0, pct)) / 100) * c;
    return (
        <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
            <svg width={size} height={size} className="-rotate-90">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    stroke={color}
                    strokeOpacity={0.18}
                    strokeWidth={stroke}
                    fill="none"
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    stroke={color}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    fill="none"
                    strokeDasharray={`${dash} ${c - dash}`}
                    style={{ transition: "stroke-dasharray 500ms cubic-bezier(0.34,1.56,0.64,1)" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="font-display font-black text-slate-900" style={{ fontSize: size * 0.22 }}>
                    {Math.round(pct)}%
                </span>
                {label && (
                    <span className="text-[9px] uppercase tracking-widest text-slate-500 font-bold">{label}</span>
                )}
            </div>
        </div>
    );
}
